import {
	LabelManagementModalConfig,
	LabelManagementModalType
} from './LabelManagementSharedModal.types';

export const LABEL_MANAGEMENT_MODAL_TYPE = {
	ADD: 'add',
	REMOVE: 'remove',
	UPDATE: 'update'
} as const;

export const APP_TYPE = {
	WSDK: 'wsdk',
	WFA: 'wfa',
	MFA: 'mfa',
	MSDK: 'msdk'
} as const;

export type AppType = (typeof APP_TYPE)[keyof typeof APP_TYPE];

export const isMobileAppType = (appType?: AppType): boolean =>
	appType === APP_TYPE.MFA || appType === APP_TYPE.MSDK;

export const LABEL_MANAGEMENT_MODAL_CONFIG: Record<
	LabelManagementModalType,
	LabelManagementModalConfig
> = {
	[LABEL_MANAGEMENT_MODAL_TYPE.ADD]: {
		className: 'add-label-tests-modal'
	},
	[LABEL_MANAGEMENT_MODAL_TYPE.REMOVE]: {
		className: 'remove-label-tests-modal'
	},
	[LABEL_MANAGEMENT_MODAL_TYPE.UPDATE]: {
		className: 'update-tests-modal'
	}
};
